module.exports = __webpack_public_path__ + "static/media/powrot.623f1d40.svg";